import React, { Component } from 'react'
import { Col, Input, FormFeedback } from 'reactstrap'

import { payer,csrPayer } from '../apis/accountManagementApis';
import EirErrorModal from './../EirErrorModal';
import EirButton from './../../eir-button/EirButton';

class EirEditExpiry extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            showEdit: true,
            showSave: false,
            months: [
                "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"
            ],
            yearList: [new Date().getFullYear()],
            monthSelected: '',
            yearSelected: '',
            invalid: false,
            csrPayerUrl:'',
            csrPayerParam:'',
            invalidMonth: false,
            invalidYear: false,
            errorModal: false,
            saveClicked: false,
            savedMonth: '',
            savedYear: '',
        }

        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {

        if (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN')  === '0_') {
            this.state.csrPayerUrl = csrPayer;            
            this.state.csrPayerParam = ``;
        }else {
            this.state.csrPayerUrl = payer;            
            this.state.csrPayerParam = ``;
        }

        for (let i = 1; i < 11; i++) {
            this.setState( prevState => ({
                yearList: [...prevState.yearList, parseInt(this.state.yearList) + i]
            }))
        }
        let date = this.props.expiry.split('/');
        this.setState({
            monthSelected: date[0],
            yearSelected: date[1]
        })
    }
    componentDidUpdate(prevProps, prevState) {
        let date = this.props.expiry.split('/');

        if (prevProps.statusChanged !== this.props.statusChanged) {
            this.setState({
                monthSelected: date[0],
                yearSelected: date[1]
            })
        }
    }
    

    handleEdit = (event) => {
        event.preventDefault();
        this.setState({
            showSave: true,
            showEdit: false,
        });
    }

    toggleError = (param) => {
        this.setState({
            errorModal: param
        })
    }

    handleCancel = (event) => {
        event.preventDefault();
        this.setState({
            showSave: false,
            showEdit: true,
        });
        if (!this.state.saveClicked) {
            let date = this.props.expiry.split('/');
            this.setState({
                monthSelected: date[0],
                yearSelected: date[1],
                invalidMonth: false,
                invalidYear: false
            })
        } else {
            this.setState({
                monthSelected: this.state.savedMonth,
                yearSelected: this.state.savedYear
            })
        }
    }

    handleSave(event) {
        event.preventDefault();

        let day;
        if (this.state.monthSelected == '01' ||
            this.state.monthSelected == '03' ||
            this.state.monthSelected == '05' ||
            this.state.monthSelected == '07' ||
            this.state.monthSelected == '08' ||
            this.state.monthSelected == '10' ||
            this.state.monthSelected == '12') {
            day = '31'
        } else
            if (this.state.monthSelected == '04' ||
                this.state.monthSelected == '06' ||
                this.state.monthSelected == '09' ||
                this.state.monthSelected == '11') {
                day = '30'
            } else
                if (this.state.yearSelected % 4 == '0' &&
                    this.state.yearSelected % 100 != '0' ||
                    this.state.yearSelected % 400 == '0') {
                    day = '29'
                }
                else {
                    day = '28'
                }

        if (!this.state.invalidMonth && !this.state.invalidYear) {
            
            this.state.csrPayerUrl.post(`${this.state.csrPayerParam}/card_payment_method/${this.props.cardId}/update_expiry_date`, {
                "expirationDate": `${this.state.yearSelected}-${this.state.monthSelected}-${day}`
            })
                .then((response) => {
                    this.setState({
                        showSave: false,
                        showEdit: true,
                        saveClicked: true,
                        savedMonth: this.state.monthSelected,
                        savedYear: this.state.yearSelected
                    })
                })
                .catch((error) => {
                    console.log('error ', error);
                    if (error.response.status === 401) {
                        return window.location.href = '/email/login'
                    }
                    this.setState({
                        errorModal: true
                    })
                })
        }
    }

    handleMonths = (event) => {
        this.setState({
            monthSelected: event.target.value
        })

        if (this.state.yearSelected == new Date().getFullYear()) {
            if (event.target.value < (new Date().getMonth() + 1)) {
                this.setState({
                    invalidMonth: true
                })
            }
            else {
                this.setState({
                    invalidMonth: false,
                    invalidYear: false
                })
            }
        }
        
    }

    handleYear = (event) => {

        this.setState({
            yearSelected: event.target.value,
        })

        if (event.target.value == new Date().getFullYear()) {
            if (this.state.monthSelected < (new Date().getMonth() + 1)) {
                this.setState({
                    invalidYear: true
                })
            }
            
        }
        else {
            this.setState({
                invalidYear: false,
                invalidMonth: false
            })
        }
        
    }

    render() {
        return (
            <React.Fragment>
                <Col xs='5' sm='5' lg='3' md='4' className='card-details-text'>
                    
                    {this.state.showEdit && this.state.monthSelected + '/' + this.state.yearSelected}

                    {this.state.showSave &&
                    <span>
                            <Input
                                className="expiry-month"
                                type="select"
                                value={this.state.monthSelected}
                                invalid={this.state.invalidMonth}
                                onChange={this.handleMonths}>
                                {this.state.months.map((month, i) => <option key={i}>{month}</option>)}
                                
                            </Input>
                            
                            <Input
                                className="expiry-year"
                                type="select"
                                value={this.state.yearSelected}
                                invalid={this.state.invalidYear}
                                onChange={this.handleYear}>
                                {this.state.yearList.map((year, i) => <option key={i}>{year}</option>)}
                            </Input>
                            <FormFeedback className="m-0 p-0 text-center col-lg-12 float-right">
                                Not valid
                            </FormFeedback>
                    </span>
                    }
                </Col>
                <Col xs='6' sm='6' lg='2' md='7'>
                    {
                        this.state.showEdit &&
                        <EirButton type='link' text='Edit Expiry' className='edit-expiry pl-1 pr-1' onClick={this.handleEdit} />
                    }

                    {
                        this.state.showSave &&
                        <span>
                            <span className="expirySave">
                                <EirButton type='link' text='Save' className='edit-expiry' onClick={this.handleSave} />
                            </span>
                            <span className="expiryCancel">
                                <EirButton type='link' text='Cancel' className='edit-expiry' onClick={this.handleCancel} />
                            </span>
                        </span>
                    }
                    
                </Col>
                {
                    this.state.errorModal &&
                    <EirErrorModal toggleError={this.toggleError} errorModal={this.state.errorModal} />
                }
            </React.Fragment>
        )
    }
}

export default EirEditExpiry
